import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import { Box } from '../Box';
import { Icon } from '../Icon';
import { Text } from '../Text';
import { theme } from '../theme';
export const Accordion = ({ title, children, onToggle, filledBackground, defaultIsOpen = false, borderTop = false, borderColor = 'oatmeal', backgroundColor = 'custard', subTitle, fullBorder = false, ...marginProps }) => {
    const [isOpen, setIsOpen] = useState(defaultIsOpen);
    const px = fullBorder ? '16px' : '0';
    const handleToggle = () => {
        const nextOpenState = !isOpen;
        onToggle?.(nextOpenState);
        setIsOpen(nextOpenState);
    };
    return (React.createElement(Wrapper, { "$borderTop": borderTop, "$fullBorder": fullBorder, "$filledBackground": filledBackground, "$borderColor": borderColor, "$backgroundColor": backgroundColor, ...marginProps },
        React.createElement(TopContainer, { flex: true, alignItems: "center", justifyContent: "space-between", onClick: handleToggle, py: "16px", pr: "16px", pl: px },
            React.createElement(TitleContainer, null,
                React.createElement(Text, { tag: "h2", typo: "headline-regular", color: "liquorice" }, title),
                subTitle && (React.createElement(Text, { tag: "label", color: "liquorice", typo: "label", mt: { custom: 4 } }, subTitle))),
            React.createElement(CaretIcon, { render: "caret", size: 24, color: "marzipan", "$isOpen": isOpen, "$borderTop": borderTop })),
        isOpen && (React.createElement(Box, { pt: "12px", pb: "16px", px: px }, children))));
};
const Wrapper = styled(Box)(({ $borderTop, $fullBorder, $filledBackground, $borderColor = 'oatmeal', $backgroundColor = 'custard', }) => css `
    border-bottom: 1px solid ${theme.colors[$borderColor]};
    ${$borderTop && `border-top: 1px solid ${theme.colors[$borderColor]};`}

    ${$fullBorder &&
    css `
      border: 1px solid ${theme.colors[$borderColor]};
      border-radius: 16px;
    `}

    ${$filledBackground &&
    css `
      background-color: ${theme.colors[$backgroundColor]};
    `}
  `);
const TitleContainer = styled.div `
  display: flex;
  flex-direction: column;
`;
const TopContainer = styled(Box) `
  cursor: pointer;
`;
const CaretIcon = styled(Icon)(({ $isOpen }) => css `
    transform: ${$isOpen ? 'rotate(180deg)' : 'rotate(0deg)'};
    transition: transform 0.6s ease;
  `);
//# sourceMappingURL=Accordion.js.map